import type { ProductStatus } from '@/common/types/product-details.type';
import type {
  ProductAvailability,
  VariantItem,
} from '@/common/types/product.type';
import type { ResponseItemType } from '@/common/types/response.type';
import { useMutation } from '@tanstack/react-query';
import Client from '@/common/utils/client.utility';

export type BasketCheckAvailabilityMutationPayload = number[];

export interface BasketCheckAvailabilityItem {
  varaintId: number;
  variants: VariantItem[];
  varinatDiscount: number;
  productVariantPrice: number;
  productPrice: number;
  picUrl: string;
  productName: string;
  productVariantName: string;
  productIsPublish: boolean;
  productVariantIsPublish: boolean;
  productStatus: ProductStatus;
  stockStatus: ProductAvailability;
  isDeleted: boolean;
  productVariantIsDeleted: boolean;
  productVariantAvailability: boolean;
}

interface BasketCheckAvailabilityResponse {
  response: BasketCheckAvailabilityItem[];
}

export type BasketCheckAvailabilityType = (
  payload: BasketCheckAvailabilityMutationPayload
) => Promise<ResponseItemType<BasketCheckAvailabilityResponse>>;

const basketCheckAvailability: BasketCheckAvailabilityType = async (
  payload
) => {
  const client = new Client();
  return await client.post(
    '/v1/Basket/Shopper/BasketCheckAvailability',
    payload
  );
};

export const useBasketCheckAvailabilityMutation = () => {
  return useMutation({
    mutationFn: async (payload: BasketCheckAvailabilityMutationPayload) =>
      await basketCheckAvailability(payload),
    retry: 1,
  });
};
